import type { TransactionView } from '../../../types/entity-types';

/**
 * Checks if a transaction is categorized as an internal transfer.
 * An internal transfer is identified by checking if the transaction's vendor
 * is categorized under "Financial Items" > "Internal Transfers".
 */
const INTERNAL_TRANSFER_CATEGORY_LEVEL_1 = 'Financial Items';
const INTERNAL_TRANSFER_CATEGORY_LEVEL_2 = 'Internal Transfers';

export const isInternalTransfer = (transaction: TransactionView): boolean => {
  // Check if the transaction has a vendor with a category
  const vendor = transaction.vendor;
  if (!vendor || !vendor.category) {
    return false;
  }

  // Check if the category is "Internal Transfers" under "Financial Items"
  const category = vendor.category;
  return (
    category.level1 === INTERNAL_TRANSFER_CATEGORY_LEVEL_1 && category.level2 === INTERNAL_TRANSFER_CATEGORY_LEVEL_2
  );
};
